export const environment = {
	automaticAuthorizerFrontEndURI: 'https://autorizador.qa.credilowcreditos.com.ar/login',
	automaticAuthorizerURI: 'https://automatic-authorizer-service.api.qa.credilowcreditos.com.ar/api',
	credilowFrontEndURI: 'https://www.qa.credilow.com.ar/',
	creditosURI: 'https://sistema.qa.credilowcreditos.com.ar/',
	googleApiKey: 'AIzaSyDohuxJ0QwtC3ZRYtBZStw5hDw0xhvPBuA',
	identityServiceURI: 'https://identity-service.api.qa.credilowcreditos.com.ar/',
	production: false,
	recaptchaSiteKey: '6Le_1rAsAAAAAHSw7W0V8riMx8E8j2zb3sI3LX3n',
	toastrTimeOut: 5000,
}
